export const CONVERSATION_TAB_KEY = 'CONVERSATION';
export const NOTES_TAB_KEY = 'NOTES';
export const SCHEDULE_MESSAGE_TAB_KEY = 'SCHEDULE_MESSAGE';
